import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../common/services/cqs/CommandType";
export class SetExternarbetsorderDestineringStatusCommand extends BasicCommand<SetExternarbetsorderDestineringStatusCommand> {
    get primaryKey() {
        return {
            externDestineringskopplingId: this.externDestineringskopplingId
        };
    }
    externDestineringskopplingId: number;
    status: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetExternarbetsorderDestineringStatusCommand";
    constructor(init: (instance: SetExternarbetsorderDestineringStatusCommand) => void) {
        super("SetExternarbetsorderDestineringStatusCommand", "Destinering", CommandType.Replace);
        init(this);
    }
}
